module.exports = __webpack_public_path__ + "img/tap.bcc641aa.png";